import { getTxtIdMapperPath } from "../../router/txtIdMapper"
import { apiS, apiS_ignore1298 } from "./api-base"
import { getESGReqHeader } from "./tool-service"

//案件編號清單查詢
export const getCaseNoDatList = async () => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1010102'),
        ReqBody: {}
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1010102")}`, method: 'post', data: ReqBody })
}

//資料登錄查詢
export const getChartDataByCaseSn = async (reqBody) => {    
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1010101'),
        ReqBody: reqBody
    }
    if(JSON.stringify(reqBody)==='{}'){//沒帶值的預設不跳查無資料        
        return await apiS_ignore1298({ url: `/${getTxtIdMapperPath("F1010101")}`, method: 'post', data: ReqBody })
    }else{
        return await apiS({ url: `/${getTxtIdMapperPath("F1010101")}`, method: 'post', data: ReqBody })
    }
}